import { Loading } from '@/common/atoms/Loading'
import TextError from '@/common/atoms/TextError'
import { Title } from '@/common/atoms/Title'
import useCurrentSeller from '@/seller/hooks/useCurrentSeller'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { nhost } from 'src/nhost'
import { EstateAddFormModal } from '../components/Estate/EstateAddFormModal'
import { EstatesCardList } from '../components/EstateCardList/EstatesCardList'
import { useEstateWithApplicationsAndVisitSpans } from '../hooks/useEstateWithApplicationsAndVisitSpans'

export const SellerEstatesPage = () => {
  const { t } = useTranslation()
  const seller = useCurrentSeller()
  const [isOpen, setIsOpen] = useState(false)

  const [includeArchived, setIncludeArchived] = useState(false)

  const {
    estates: allEstates,
    loading,
    error,
  } = useEstateWithApplicationsAndVisitSpans()

  const estates = useMemo(() => {
    return includeArchived
      ? allEstates
      : allEstates?.filter((estate) => !estate.archived)
  }, [allEstates, includeArchived])

  const logoUrl = useMemo(() => {
    if (!seller?.logo) return
    // TODO maybe replace by nhost.storage.getPresignedUrl
    return nhost.storage.getPublicUrl({
      fileId: seller?.logo,
    })
  }, [seller])

  const canCreateEstate = seller?.canEditAndCreateEstate ?? false

  return (
    <>
      <Title>{t('SellerEstatesPage.heading')}</Title>
      {loading && <Loading center active />}
      {error && <TextError error={error} />}

      <div className="tw-bg-[#EBFFF6] tw-max-h-[200px] tw-w-full tw-flex tw-items-center tw-justify-between tw-p-8 tw-overflow-hidden tw-relative">
        <div>
          {logoUrl && (
            // eslint-disable-next-line @next/next/no-img-element
            <img
              src={logoUrl}
              alt="Logo"
              className="tw-max-h-[100px] tw-object-cover"
            />
          )}
          <p className="tw-text-lg tw-font-medium tw-mt-6">
            {estates?.length === 0 && !canCreateEstate
              ? t('SellerEstatesPage.description_zero_cant_add', {
                  agency: seller?.agency?.name,
                })
              : t('SellerEstatesPage.description', {
                  count: estates?.length,
                })}
          </p>
        </div>
        {canCreateEstate && (
          <EstateAddFormModal isOpen={isOpen} setIsOpen={setIsOpen} />
        )}
      </div>
      <EstatesCardList
        estates={estates}
        setIncludeArchived={setIncludeArchived}
        canCreateEstate={canCreateEstate}
      />
    </>
  )
}
